module.exports = __webpack_public_path__ + "img/CAL-UHF_Impulse.b1d3fc49.webp";